import {connect}  from 'react-redux';

function Result({questions, userAnswers}) {
	const result = [];

	let amountOfCorrect = 0;
	
	for (let i = 0; i < questions.length; i++) {
		if (+questions[i].correctAnswer === userAnswers[i]) {
			amountOfCorrect++;
		}
	}
	
	for (let i = 0; i < questions.length; i++) {
		result.push(<h2 key={'h2'+i}>Вопрос {i +1}.</h2>);
		
		// Текст вопроса
		result.push(
			<div className="questionBlock marginBottom20" key={'question'+i} dangerouslySetInnerHTML={{__html: questions[i].question}} />
		);

		result.push(
			<div className="resultTextPhrase" key={'your_answer_phrase'+i}>Ваш ответ:</div>
		);

		// Текст ответа пользователя, выбирается цвет фона в зависимости от правильности ответа.		
		result.push(
			<div className="answersBlock" key={'answer' + i}>
				<div className={ (+questions[i].correctAnswer === userAnswers[i]) ? 'oneAnswer greenBackground' : 'oneAnswer redBackground' }>
					<div className="index">{userAnswers[i]}</div>
					<div className="text" dangerouslySetInnerHTML={{__html: questions[i].answers[userAnswers[i] - 1]}} />
				</div>
			</div>
		);

		// Если ответ пользователя был неправильный, показываю правильный ответ.
		if (+questions[i].correctAnswer !== userAnswers[i]) {
			result.push(
				<div className="resultTextPhrase" key={'correct_answer_phrase'+i}>Правильный ответ:</div>
				,
				<div className="answersBlock" key={'correct_answer' + i}>
					<div className="oneAnswer">
						<div className="index">{questions[i].correctAnswer}</div>
						<div className="text" dangerouslySetInnerHTML={{__html: questions[i].answers[(+questions[i].correctAnswer - 1)]}} />
					</div>
				</div>
			);
		}
		
		result.push(
			<br key={'br' + i + '_1'}/>,
			<br key={'br' + i + '_2'}/>
		);
	}
	
	return (
		<div className="resultBlockWrapper">
			<h2>Результаты ваших ответов.</h2>
			<br />
			<div className="resultTextPhrase">Количество правильных ответов: {amountOfCorrect} из {questions.length}.</div>
			<br />
			<br />
			{result}
		</div>
	);
};

const mapStateToProps = (state) =>  {
	return {questions: state.questions, userAnswers: state.userAnswers};
};

export default connect(mapStateToProps)(Result);
